export enum LocalStorage {
  LastMonthCalled = "seq-his-lastMonthCalled",
  SequenceFilters = "sequenceFilters",
  Profile = "seq-his-profile",
  Versions = "seq-his-versions",
  KnownIssues = "seq-his-knownIssues",
  EmulatedUser = "seq-his-emulatedUser",
  RecentEmulates = "seq-his-recentEmulates",
}
